// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "segments-1Rp73";
var _4 = "segment-3pjJE";
var _5 = "segment__info-3MxHd";
var _6 = "segment__airports-SlCjf";
var _7 = "segment__date-lsoiy";
export { _1 as "__esModule", _2 as "mobile", _3 as "segments", _4 as "segment", _5 as "segment__info", _6 as "segment__airports", _7 as "segment__date" }
export default { "__esModule": _1, "mobile": _2, "segments": _3, "segment": _4, "segment__info": _5, "segment__airports": _6, "segment__date": _7 }
